import wcHelper from '@/scripts/helpers/webcall-helper';
import r from '../core';

export default {
  getComments(options, callback) {
    options.url = API_URL + 'video/' + options.video_id + '/comments';
    options.params = {};
    options.params.per_page = options.per_page ? options.per_page : 10;
    options.params.current_page = options.current_page;
    if (options.sort_by) {
      options.params.sort_by = options.sort_by;
    }
    return r.get(options, callback);
  },

  getCommentVote(options, callback) {
    options.url = API_URL + 'video/' + options.video_id + '/comment/' + options.comment_id + '/upvote';
    return r.get(options, callback);
  },

  postComment(options, callback) {
    options.url = API_URL + 'video/' + options.video_id + '/comment';
    return r.post(options, callback);
  },

  deleteComment(options, callback) {
    // /admin/video/:video_id/comment/:comment_id
    options.url = API_URL + 'video/' + options.video_id + '/comment/' + options.comment_id;
    return r.delete(options, callback);
  },

  getRelatedVideoTag(options, callback) {
    let limit = 12;
    if (options.limit) {
      limit = options.limit;
    }
    options.url = API_URL + 'video/' + options.video_id + '/related_endpoints?limit=' + limit;
    return r.get(options, callback);
  },

  getRelatedVideoByTag(options, callback) {
    options.url = API_URL + options.url;
    return r.get(options, callback)
      .then(response => ({
        ...response,
        videos: wcHelper.processArray(response.videos, wcHelper.get.VideoData),
      }));
  },

  getSources(options, callback) {
    if (options.source !== 'undefined') {
      options.url = API2_URL + 'video/' + options.video_id + '/sources?token=' + options.page_token + '&source=' + options.source;
    } else {
      options.url = API2_URL + 'video/' + options.video_id + '/sources?token=' + options.page_token;
    }
    return r.get(options, callback);
  },

  getHostedSources(options, callback) {
    options.url = API2_URL + 'video/' + options.video_id + '/sources/hosted?token=' + options.page_token;
    return r.get(options, callback);
  },

  postVideoWatch(options, callback) {
    options.url = API_URL + 'video/' + options.video_id + '/watch';
    return r.get(options, callback);
  },
};
